function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { forwardRef, useCallback, useContext, useEffect, useRef, useState } from "react";
import Option from "./Option/index";
import findIndex from "lodash.findindex";
import useStyle from "./Magazine.style";
import useComposedRef from "../../hooks/useComposedRef";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { FlagsContext } from "../FlagsProvider/index";
import { POPPER_ZINDEX, ZIndexContext } from "../ZIndexProvider";
var cleanOptions = function(options) {
    return options.reduce(function(accumulator, option) {
        var newOption = typeof option === 'string' ? {
            label: option,
            value: option
        } : option;
        if (accumulator.valueCheck.indexOf(newOption.value) === -1) {
            if (typeof option === 'string') {
                newOption.label = option;
                newOption.value = option;
            } else {
                if (option.label === undefined) {
                    newOption.label = option.value;
                }
            }
            return {
                valueCheck: _toConsumableArray(accumulator.valueCheck).concat([
                    newOption.value
                ]),
                noDuplicateOptions: _toConsumableArray(accumulator.noDuplicateOptions).concat([
                    newOption
                ])
            };
        }
        return accumulator;
    }, {
        valueCheck: [],
        noDuplicateOptions: []
    }).noDuplicateOptions;
};
var Magazine = forwardRef(function(_param, ref) {
    var ariaLabelledby = _param.ariaLabelledby, focusOnMount = _param.focusOnMount, forwardedRef = _param.forwardedRef, _handleClose = _param.handleClose, id = _param.id, isRtl = _param.isRtl, magazineStyleObject = _param.magazineStyleObject, onUpdate = _param.onUpdate, _options = _param.options, optionStyleObject = _param.optionStyleObject, refToFocusOnKeyboardInput = _param.refToFocusOnKeyboardInput, selected = _param.selected, testID = _param.testID, theme = _param.theme, zIndexIn = _param.zIndex, propDrop = _objectWithoutProperties(_param, [
        "ariaLabelledby",
        "focusOnMount",
        "forwardedRef",
        "handleClose",
        "id",
        "isRtl",
        "magazineStyleObject",
        "onUpdate",
        "options",
        "optionStyleObject",
        "refToFocusOnKeyboardInput",
        "selected",
        "testID",
        "theme",
        "zIndex"
    ]);
    var magazineRef = useRef(null);
    var composedMagazineRef = useComposedRef(forwardedRef, ref, magazineRef);
    var _$ref;
    var zIndexUpdates = ((_$ref = useContext(FlagsContext)) !== null && _$ref !== void 0 ? _$ref : {}).zIndexUpdates;
    var _$ref1;
    var getPopperZIndex = ((_$ref1 = useContext(ZIndexContext)) !== null && _$ref1 !== void 0 ? _$ref1 : {}).getPopperZIndex;
    var zIndex = parseInt("".concat(theme.depth.zIndex[800]), 10) + 1;
    if (zIndexUpdates) {
        if (zIndexIn) {
            zIndex = zIndexIn;
        } else {
            var _$ref2;
            zIndex = (_$ref2 = getPopperZIndex === null || getPopperZIndex === void 0 ? void 0 : getPopperZIndex()) !== null && _$ref2 !== void 0 ? _$ref2 : POPPER_ZINDEX;
        }
    }
    var _$ref3 = _slicedToArray(useState(undefined), 2), currentFocus = _$ref3[0], setCurrentFocus = _$ref3[1];
    var _$ref4 = _slicedToArray(useState(cleanOptions(_options)), 2), options = _$ref4[0], setOptions = _$ref4[1];
    var _$ref5 = _slicedToArray(useState(false), 2), filterActive = _$ref5[0], setFilterActive = _$ref5[1];
    var _$ref6 = _slicedToArray(useState(''), 2), filterString = _$ref6[0], setFilterString = _$ref6[1];
    var baseStyles = useStyle({
        isRtl: isRtl
    }).baseStyles;
    useEffect(function() {
        setOptions(cleanOptions(_options));
    }, [
        _options
    ]);
    var handleOutsideClick = useCallback(function(param) {
        var target = param.target;
        if (_instanceof(target, HTMLElement) && target !== magazineRef.current && !target.contains(magazineRef.current)) {
            target.focus();
            setCurrentFocus(undefined);
        }
    }, [
        magazineRef
    ]);
    useEffect(function() {
        if (focusOnMount) {
            setTimeout(function() {
                if (magazineRef.current) {
                    magazineRef.current.focus();
                }
            }, 100);
        }
        document.addEventListener('click', handleOutsideClick);
        return function() {
            return document.removeEventListener('click', handleOutsideClick);
        };
    }, [
        focusOnMount,
        handleOutsideClick,
        magazineRef
    ]);
    var handleWrapperFocus = function(event) {
        if (event) {
            event.stopPropagation();
            if (currentFocus === undefined) {
                var selectedIndex = findIndex(options, function(option) {
                    return option.value === selected;
                });
                setCurrentFocus(selectedIndex === -1 ? getNextFocusable(undefined, 1) : selectedIndex);
            }
        }
    };
    var buildOptionsElements = function() {
        return options.map(function(option, index) {
            return _jsx(Option, {
                id: id ? "".concat(id, "__").concat(option.value) : undefined,
                optionIndex: index,
                option: option,
                theme: theme,
                onUpdate: handleSelect,
                focused: currentFocus === index,
                selected: selected === option.value,
                setCurrentFocus: setCurrentFocus,
                isRtl: isRtl,
                testID: testID,
                optionStyleObject: optionStyleObject
            }, index);
        });
    };
    var handleSelect = function(option, optionIndex) {
        setCurrentFocus(optionIndex);
        onUpdate(option);
        handleClose();
    };
    var handleKeyDown = function(event) {
        var key = event.key, keyCode = event.keyCode;
        switch(true){
            case key === 'ArrowDown':
                handleArrowKeyPress(1, event);
                break;
            case key === 'ArrowUp':
                handleArrowKeyPress(-1, event);
                break;
            case key === 'Escape':
                handleClose();
                break;
            case key === 'Tab':
                handleClose();
                break;
            case key === 'Home':
                setCurrentFocus(getNextFocusable(undefined, 1));
                break;
            case key === 'End':
                setCurrentFocus(getNextFocusable(options.length, -1));
                break;
            case keyCode > 47 && keyCode !== 127:
                handleFilterKey(key);
                break;
            default:
                break;
        }
    };
    var handleFilterKey = function(key) {
        if (refToFocusOnKeyboardInput === null || refToFocusOnKeyboardInput === void 0 ? void 0 : refToFocusOnKeyboardInput.current) {
            setCurrentFocus(undefined);
            refToFocusOnKeyboardInput.current.focus();
        } else {
            utilizeInternalKeyboardFiltering(key);
        }
    };
    var utilizeInternalKeyboardFiltering = function(key) {
        if (filterActive) {
            setFilterString(filterString + key);
            matchOptionsToFilter();
        } else {
            setFilterActive(true);
            setFilterString(key);
            matchOptionsToFilter();
            setTimeout(function() {
                setFilterActive(false);
                setFilterString('');
            }, 3000);
        }
    };
    var matchOptionsToFilter = function() {
        var matchesMiddle = [];
        for(var i = 0; i < options.length; i++){
            var option = options[i];
            var useLabel = typeof option !== 'string' && typeof option.label === 'string';
            var useValue = typeof option !== 'string' && typeof option.value === 'string';
            var stringForFilter = useLabel && option.label || useValue && option.value || '';
            if (typeof stringForFilter === 'string') {
                if (stringForFilter.toLowerCase().startsWith(filterString.toLowerCase())) {
                    setCurrentFocus(i);
                    break;
                } else if (stringForFilter.toLowerCase().includes(filterString.toLowerCase())) {
                    matchesMiddle.push(i);
                }
            }
        }
        if (matchesMiddle.length > 0) {
            setCurrentFocus(matchesMiddle[0]);
        }
    };
    var getNextFocusable = function(optionIndex, iterateBy) {
        var optionsLength = options.length - 1;
        var startTopOrBottom = iterateBy === -1 ? optionsLength : 0;
        var nextOptionIndex = optionIndex === undefined ? startTopOrBottom : optionIndex + iterateBy;
        var option = options[nextOptionIndex];
        if (typeof option !== 'string') {
            if ((option === null || option === void 0 ? void 0 : option.disabled) || (option === null || option === void 0 ? void 0 : option.heading)) {
                if (iterateBy === 1 && (optionIndex !== null && optionIndex !== void 0 ? optionIndex : startTopOrBottom) < optionsLength || iterateBy === -1 && (optionIndex !== null && optionIndex !== void 0 ? optionIndex : startTopOrBottom) > 1) {
                    return getNextFocusable(nextOptionIndex, iterateBy);
                }
                return optionIndex;
            }
        }
        return nextOptionIndex;
    };
    var handleArrowKeyPress = function(iterateBy, event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        var optionsLength = options.length - 1;
        if (typeof currentFocus === 'undefined' || iterateBy === 1 && currentFocus < optionsLength || iterateBy === -1 && currentFocus > 0) {
            setCurrentFocus(getNextFocusable(currentFocus, iterateBy));
        }
    };
    var handleClose = function() {
        return _handleClose === null || _handleClose === void 0 ? void 0 : _handleClose();
    };
    var currentFocusedOption = currentFocus ? options[currentFocus] : undefined;
    var activeDescendant = function() {
        if (typeof currentFocusedOption !== 'string') {
            if (!id || typeof currentFocus !== 'number' || !(currentFocusedOption === null || currentFocusedOption === void 0 ? void 0 : currentFocusedOption.value)) {
                return;
            }
            return "".concat(id, "__").concat(currentFocusedOption === null || currentFocusedOption === void 0 ? void 0 : currentFocusedOption.value);
        }
    };
    var _$ref7;
    return _jsx("ul", _objectSpread({}, propDrop, {
        id: id,
        "aria-labelledby": (_$ref7 = propDrop === null || propDrop === void 0 ? void 0 : propDrop['aria-labelledby']) !== null && _$ref7 !== void 0 ? _$ref7 : ariaLabelledby,
        "aria-activedescendant": activeDescendant()
    }, injectTestId(testID ? testID + '-magazine' : undefined), {
        css: _objectSpread({}, baseStyles, {
            zIndex: zIndex
        }, magazineStyleObject),
        ref: composedMagazineRef,
        tabIndex: -1,
        onKeyDown: handleKeyDown,
        role: "menu",
        onFocus: handleWrapperFocus,
        onClick: handleOutsideClick,
        children: buildOptionsElements()
    }));
});
export { Magazine };
export default Magazine;
